









import Vue from 'vue'
import { mapActions } from 'vuex'
import UiGallery from '@/components/ui/UiGallery.vue'
import ConsultationModal from '@/components/modules/App/Consultation.vue'
import BookingOnlineModal from '@/components/modules/App/BookingOnline.vue'
import StateDutyModal from '@/components/modules/App/Deal/StateDutyModal.vue'

export default Vue.extend({
  name: 'MainAppPage',
  components: {
    UiGallery,
    ConsultationModal,
    BookingOnlineModal,
    StateDutyModal
  },
  created () {
    this.getUserData()
  },
  methods: {
    ...mapActions(['getUserData'])
  }
})
